<template>
  <div class="circle-progressbar">
    <div class="progressbar" :style="[progressbarStyle]">
      <div class="left-container" :style="[containerStyle,left]">
        <div class="left-circle" :style="[circleStyle,leftCircleStyle,leftRotateStyle]"></div>
      </div>
      <div class="right-container" :style="[containerStyle,right]">
        <div class="right-circle" :style="[circleStyle,rightCircleStyle,rightRotateStyle]"></div>
      </div>
      <slot>
        <div class="title">
          {{this.pv}}
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
  const DEFAULT_WIDTH = 100,
    DEFAULT_BLOD = 5,
    DEFAULT_COLOR = '#03A9F5',
    DEFAULT_BG_COLOR = '#1F2037';
  export default {
    name: 'ring',
    props: {
      'pv': {
        default: 100
      },
      'color': String,
      'width': [Number, String],
      'bgColor': String,
      'blod': [Number, String],
    },
    watch: {
      pv() {
        this.setTransformStyle()
      }
    },


    computed: {
    },
    data() {
      let width = (this.width || DEFAULT_WIDTH),
        color = (this.color || DEFAULT_COLOR),
        bgColor = (this.bgColor || DEFAULT_BG_COLOR),
        blod = (this.blod || DEFAULT_BLOD),
        circleWidth = (width - 2 * blod) + 'px',
        containWidth = (width / 2 - blod) + 'px';
      return {
        progressbarStyle: {
          height: circleWidth,
          width: circleWidth,
          borderColor: bgColor,
          borderWidth: blod + 'px',
          borderStyle: 'solid',
          // backgroundColor: bgColor
        },
        containerStyle: {
          width: containWidth,
          height: width + 'px',
          top: -blod + 'px',
        },
        circleStyle: {
          width: circleWidth,
          height: circleWidth,
          borderWidth: blod + 'px',
        },
        rightCircleStyle: {
          borderRightColor: color,
          borderBottomColor: color,
        },
        leftCircleStyle: {
          borderTopColor: color,
          borderLeftColor: color,
        },
        right: {
          right: -blod + 'px'
        },
        left: {
          left: -blod + 'px'
        },
        leftRotateStyle: {},
        rightRotateStyle: {},
      }
    },
    created() {


    },
    mounted() {
    },
    methods: {
      setTransformStyle() {
        let pv = this.pv ? this.pv : 0,
          left = 135,
          right = 135,
          deg;
        pv = pv ? pv : 0;
        if (pv < 50) {
          deg = Math.floor((180 / 50) * pv);
          right = 135 + deg
        } else {
          right = 315;
          deg = Math.floor((180 / 50) * (pv - 50));
          left = 135 + deg
        }
        let transformStyleValue = {
          left: `rotate(${left}deg)`,
          right: `rotate(${right}deg)`,
        }

        this.leftRotateStyle = {
          transform: transformStyleValue.left,
          webkitTransform: transformStyleValue.left,
          msTransform: transformStyleValue.left,
          oTransform: transformStyleValue.left,
          mozTransform: transformStyleValue.left
        },
          this.rightRotateStyle = {
            transform: transformStyleValue.right,
            webkitTransform: transformStyleValue.right,
            msTransform: transformStyleValue.right,
            oTransform: transformStyleValue.right,
            mozTransform: transformStyleValue.right
          }
      }
    }
  }
</script>

<style type="scss" scoped>
  .circle-progressbar {
    position: relative;
  }

  .progressbar {
    position: relative;
    border-radius: 50%;
    margin: 0 auto;
  }

  .left-container, .right-container {
    position: absolute;
    overflow: hidden;
    z-index: 1;
  }

  .left-circle, .right-circle {
    position: absolute;
    top: 0;
    border: solid transparent;
    border-radius: 50%;
    transform: rotate(135deg);
    transition: all .5s linear;
    z-index: 2;
  }


  .left-circle {
    left: 0;
    border-top-color: blue;
    border-left-color: blue;
    transition-delay: .5s;

  }

  .right-circle {
    border-right-color: blue;
    border-bottom-color: blue;
    right: 0;
  }

  .title {
    position: absolute;
    left: 50%;
    top: 50%
  }
</style>




// WEBPACK FOOTER //
// src/components/rings.vue